﻿import {CreateOrSelectDriverModel} from "../components/CreateOrSelectDriverComponent";
import {CreateOrSelectResidencyModel} from "../components/CreateOrSelectResidencyComponent";
import {CreateOrSelectVehicleModel} from "../components/CreateOrSelectVehicleComponent";
import {Drivers} from "../Drivers";
import {Residencies} from "../Residencies";
import {AllPermitsResult} from "../types/AllPermitsResult";
import {DriverResult} from "../types/DriverResult";
import {ResidencyResult} from "../types/ResidencyResult";
import {VehicleResult} from "../types/VehicleResult";
import {Vehicles} from "../Vehicles";


export function toResidencyResult(residency: CreateOrSelectResidencyModel, permits: AllPermitsResult): ResidencyResult {
	return residency.residencyId === "create" ? {
		id: null!,
		address: residency.arguments.address,
		suffix: residency.arguments.suffix,
		uses: residency.arguments.uses,
		zoneId: residency.arguments.zoneId,
		attachments: [],
		customData: []
	} : Residencies.get(permits, residency.residencyId);
}

export function toDriverResult(driver: CreateOrSelectDriverModel, permits: AllPermitsResult): DriverResult {
	return driver.driverId === "create"
		? {
			id: null!,
			fullName: driver.arguments.fullName,
			licenseNumber: driver.arguments.licenseNumber,
			attachments: [],
			customData: []
		}
		: Drivers.get(permits, driver.driverId);
}

function toVehicleResult(vehicle: CreateOrSelectVehicleModel, permits: AllPermitsResult): VehicleResult {
	return vehicle.vehicleId === "create"
		? {
			id: null!,
			plate: vehicle.arguments.plate,
			data: vehicle.arguments.data,
			type: vehicle.arguments.type,
			attachments: [],
			customData: []
		}
		: Vehicles.get(permits, vehicle.vehicleId)
}

export function toVehicleResults(vehicles: CreateOrSelectVehicleModel[], permits: AllPermitsResult): VehicleResult[] {
	return vehicles.map(v => toVehicleResult(v, permits));
}
